var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"mode":"report","items":_vm.reports},on:{"load":_vm.onLoad,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }